import { Col, Row } from "antd";
import { useState } from "react";
import { MdAddCircle } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../../components";
import DatePickerInput from "../../../../../components/datePickerInput/DatePickerInput";
import Dropdown from "../../../../../components/dropdowns/Dropdown";
import { CalendarIcon, ClockIcon } from "../../../../../components/icons/Icons";
import TimePickerInput from "../../../../../components/timePickerInput/TimePickerInput";
import styles from "./AddNewTask.module.css";
import { IoMdCloseCircle } from "react-icons/io";
import Modal from "../../../../../components/modal/Modal";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";

import { CheckListMiddleware } from "../../../../../Store/Middlewares/CheckListMiddleware";
import moment from "moment";
import dayjs from "dayjs";

const SvgChild = (
  <>
    <g opacity="0.5">
      <rect
        x="0.183594"
        y="262.64"
        width="764.919"
        height="762.387"
        rx="381.194"
        transform="rotate(-20.0528 0.183594 262.64)"
        fill="var(--primary-color)"
      />
      <g clip-path="url(#clip0_58_1397)">
        <g clip-path="url(#clip1_58_1397)">
          <path
            d="M410.38 341.295C397.905 331.255 385.918 330.489 375.627 338.848C365.221 347.298 363.64 361.604 372.294 372.249C374.432 374.868 374.648 376.606 373.125 379.602C354.645 415.828 361.104 458.137 389.66 487.319C407.003 505.054 424.584 522.55 442.143 540.08C452.515 550.44 452.811 566.78 442.644 577.38C435.24 585.099 434.854 595.996 441.757 602.846C448.751 609.798 459.304 609.364 466.981 601.645C522.807 545.534 578.611 489.389 634.461 433.289C639.135 428.601 642.103 423.318 641 416.537C638.862 403.455 624.26 398.332 612.706 406.817C606.724 411.208 600.48 414.238 592.997 414.387C584.263 414.559 576.769 411.677 570.492 405.479C554.047 389.253 537.432 373.199 521.079 356.892C491.556 327.436 449.854 320.941 412.666 340.209C412.007 340.54 411.324 340.849 410.38 341.295ZM453.368 364.474C468.72 364.828 482.595 369.402 494.558 379.282C495.434 380.002 496.242 380.803 497.083 381.557C500.142 384.279 501.609 387.561 498.562 390.9C495.605 394.159 492.568 392.489 489.702 390.019C470.824 373.759 449.353 371.518 428.053 383.501C424.71 385.377 421.048 386.898 418.819 382.541C416.874 378.767 418.045 375.36 422.083 373.004C431.783 367.344 442.268 364.828 453.368 364.474Z"
            fill="white"
          />
          <path
            d="M573.55 588.266C593.144 587.408 608.85 577.837 617.311 558.512C625.647 539.473 622.633 521.417 609.191 505.431C604.653 500.034 601.947 500 597.079 504.882C577.701 524.322 558.345 543.784 539.012 563.269C533.929 568.392 534.088 570.953 539.581 575.905C548.383 583.829 560.062 588.254 573.55 588.266Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_58_1397">
        <rect
          x="193.105"
          y="304.267"
          width="513.551"
          height="525.222"
          rx="256.775"
          transform="rotate(-20.0528 193.105 304.267)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_58_1397">
        <rect
          width="278.52"
          height="278.52"
          fill="white"
          transform="matrix(-1 0 0 1 641.227 329.242)"
        />
      </clipPath>
    </defs>
  </>
);

const svgViewBox = "0 0 715 724";

const AddNewTask = () => {
  const { state } = useLocation();
  const { task } = state;
  const [modalOpen, setModalOpen] = useState(false);
  const [taskName, setTaskName] = useState(task?.name ? task?.name : "");
  const [description, setdescription] = useState(
    task?.description ? task?.description : ""
  );
  // const [subtaskList, setsubtaskList] = useState(
  //   task?.sub_tasks ? task?.sub_tasks : []
  // );
  const [startTime, setstartTime] = useState();
  const [hours, sethours] = useState(
    task?.remind_after ? task?.remind_after : null
  );
  const [date, setdate] = useState(task?.date ? task?.date : "");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const onPressPlus = () => {
  //   if (!subtaskName) {
  //     dispatch(
  //       showAlert({
  //         title: "Add sub task",
  //         message: "Enter sub task name.",
  //         type: "Error",
  //         status: 400,
  //       })
  //     );
  //     return;
  //   } else {
  //     subtaskList.push({ id: null, is_completed: false, name: subtaskName });
  //     setsubTaskName("");
  //   }
  // };

  const onCreateTask = () => {
    let checklistData = {
      taskName,
      description,
      // time: startTime,
      // hours: hours,
      date: moment(date).format("YYYY-MM-DD"),
      id: state?.eventData?.id,
    };
    dispatch(CheckListMiddleware.createCheckList(checklistData))
      .then(() => navigate(-1))
      .catch((err) => console.log(err));
  };

  const onEditTask = () => {
    if (!taskName || !date) {
      dispatch(
        showAlert({
          title: "Edit task",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      let checklistData = {
        taskName,
        description,
        // time: startTime ? startTime : moment(task?.time).format("hh:mm a"),
        // hours: hours,
        date: moment(date).format("YYYY-MM-DD"),
        task_id: task?.id,
        // status: Action,
      };
      dispatch(CheckListMiddleware.editCheckList(checklistData))
        .then(() => navigate(-1))
        .catch((err) => console.log(err));
    }
  };
  function disabledDate(current) {
    let startDate = moment().subtract(1, "days");
    let endDate = moment( state?.eventData?.date).add(1, "days");
    
    return current < startDate || current > endDate;
  }
  return (
    <>
      <Row className={styles.secondStepContainer} gutter={16}>
        <Col xs={24}>
          <InputField
            label="Task"
            placeholder="Task Name"
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
          />
        </Col>

        <Col xs={24}>
          <TextareaField
            label="Description"
            placeholder="This task is about..."
            value={description}
            onChange={(e) => setdescription(e.target.value)}
          />
        </Col>
        {/* <Col xs={24} md={24}>
          <Row className={styles.inputRow}>
            <Col xs={20} sm={21} md={22} xl={23}>
              <InputField
                label={"Sub Task"}
                type={"text"}
                value={subtaskName}
                onChange={(e) => setsubTaskName(e.target.value)}
                // name={inp.name}
                // rightIcon={rightIcon}
                placeholder={"Sub Task"}
                // onChange={handleValues}
              />
            </Col>
            <Col xs={4} sm={3} md={2} xl={1} className={styles.addBtnCol}>
              <MdAddCircle
                size={25}
                className={styles.addBtn}
                onClick={onPressPlus}
              />
            </Col>
          </Row>
        </Col> */}

        {/* {subtaskList.map((item, index) => (
          <Col xs={24} md={24} key={index}>
            <Row className={styles.inputRow}>
              <Col xs={20} sm={21} md={22} xl={23}>
                <InputField
                  label={"Sub Task"}
                  type={"text"}
                  value={item.name}
                  placeholder={"Sub Task"}
                  disabled
                  // onChange={handleValues}
                />
              </Col>
              <Col xs={4} sm={3} md={2} xl={1} className={styles.addBtnCol}>
                <IoMdCloseCircle
                  size={25}
                  className={styles.addBtn}
                  onClick={() => {
                    setsubtaskList((prev) =>
                      prev.filter((item, i) => index != i)
                    );
                  }}
                />
              </Col>
            </Row>
          </Col>
        ))} */}
        {/* <Col xs={24} md={12}>
          <TimePickerInput
            label="Set Time"
            icon={<ClockIcon size={25} />}
            defaultValue={task?.time ? dayjs(task?.time) : ""}
            onChange={(val, t) => setstartTime(t)}
          />
        </Col>
        <Col xs={24} md={12}>
          <Dropdown
            stylesClass={styles.dropdownClass}
            placeholder={"2 Hr"}
            // name={"role"}
            selectedValue={hours ? (hours == 1 ? "2 Hr" : "5 Hr") : ""}
            onChange={(val) => sethours(val.id)}
            label={"Remind Me After"}
            object={[
              { id: 1, name: "2 Hr" },
              { id: 2, name: "5 Hr" },
            ]}
          />
        </Col> */}
        <Col xs={24} md={12}>
          <DatePickerInput
            label="Date"
            icon={<CalendarIcon size={25} />}
            defaultValue={date ? dayjs(date) : ""}
            onChange={(val, d) => setdate(d)}
            disabledDate={disabledDate}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Event Name"
            // placeholder="Wedding Dress"
            value={state?.eventData?.name}
            disabled
            // onChange={(e) => setTaskName(e.target.value)}
          />
        </Col>
      </Row>
      <SubmitButton
        title={task ? "Update" : "Create"}
        btnClass={styles.solidBtn}
        onClick={() => {
          if (task) {
            setModalOpen(true);
            return;
          }
          if (!taskName || !description || !date) {
            dispatch(
              showAlert({
                title: "Create task",
                message: "All fields are mandatory.",
                type: "Error",
                status: 400,
              })
            );
            return;
          } else {
            setModalOpen(true);
          }
        }}
      />
      <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        svgBg={SvgChild}
        viewBox={svgViewBox}
      >
        <Row className={styles.modalContent}>
          <svg
            className={styles.bellIcon}
            viewBox="0 0 248 248"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M205.672 11.002C216.735 2.09862 227.365 1.41921 236.492 8.83192C245.719 16.3258 247.121 29.0115 239.447 38.4524C237.551 40.7745 237.359 42.3159 238.71 44.9727C255.099 77.0979 249.37 114.618 224.047 140.496C208.667 156.224 193.076 171.739 177.504 187.285C168.307 196.472 168.045 210.963 177.061 220.363C183.626 227.208 183.969 236.872 177.847 242.946C171.645 249.111 162.286 248.726 155.479 241.881C105.971 192.122 56.4839 142.332 6.95636 92.5824C2.81141 88.4248 0.179219 83.7399 1.15747 77.7266C3.05345 66.1258 16.0026 61.5829 26.249 69.1071C31.5537 73.0011 37.0904 75.6883 43.7264 75.8202C51.4717 75.9723 58.1177 73.4169 63.6847 67.9207C78.2676 53.5313 93.0018 39.294 107.504 24.8337C133.685 -1.28831 170.667 -7.04812 203.645 10.0386C204.23 10.3327 204.835 10.6065 205.672 11.002ZM167.55 31.5568C153.936 31.8712 141.632 35.9274 131.022 44.6888C130.246 45.3276 129.53 46.0375 128.784 46.7067C126.071 49.1202 124.77 52.0305 127.472 54.9915C130.095 57.8816 132.787 56.4011 135.329 54.2107C152.07 39.7909 171.11 37.8034 190 48.4306C192.965 50.0937 196.212 51.4424 198.189 47.5788C199.913 44.2325 198.874 41.2106 195.294 39.1216C186.692 34.1021 177.393 31.8712 167.55 31.5568Z"
              className={styles.bellIconPath}
            />
            <path
              d="M60.9714 230.017C43.5949 229.257 29.6675 220.769 22.1642 203.632C14.7719 186.748 17.4445 170.736 29.365 156.559C33.3889 151.773 35.7891 151.743 40.1055 156.073C57.2904 173.311 74.4551 190.571 91.5997 207.85C96.1077 212.393 95.9665 214.664 91.0954 219.055C83.2896 226.083 72.9323 230.007 60.9714 230.017Z"
              className={styles.bellIconPath}
            />
          </svg>

          <TextComponent textClass={styles.modalText1}>
            {task ? "Update Task" : "Create Task"}
          </TextComponent>
          <TextComponent textClass={styles.modalText2}>
            {taskName}
          </TextComponent>
          <SubmitButton
            title={task ? "Update" : "Create"}
            btnClass={styles.modalBtn}
            onClick={task ? onEditTask : onCreateTask}
          />
          <SubmitButton
            title="Cancel"
            outline={true}
            btnClass={styles.modalBtn}
            onClick={() => setModalOpen(false)}
          />
        </Row>
      </Modal>
    </>
  );
};

export default AddNewTask;
